/* ChicChac — product page enhancement (founder change-set)
   - "Add to Wishlist" as a proper labelled button (icon + text), toggles state.
     Shares the localStorage wishlist used by the product cards (key cc_wishlist).
   - Pincode delivery check near add-to-cart → client-side estimate stub.
     Real serviceability = Shiprocket API (needs account) — see
     docs/launch/shiprocket-setup-guide.md.
   No external dependencies. */
(function () {
  'use strict';
  var WKEY = 'cc_wishlist';
  function wl() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function saveWl(a) {
    try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {}
    /* keep the header wishlist count (cc-wishlist.js) in sync */
    try { document.dispatchEvent(new CustomEvent('cc:wishlist', { bubbles: true })); } catch (e) {}
  }

  var HEART = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 21s-7.5-4.9-10-9.2C.6 9 1.7 5.6 4.8 5c1.9-.3 3.5.6 4.4 2 .9-1.4 2.5-2.3 4.4-2 3.1.6 4.2 4 2.8 6.8C19.5 16.1 12 21 12 21z"/></svg>';
  var TRUCK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>';

  function handle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function buildWishlist(anchor, h) {
    if (document.querySelector('.cc-pdp-wishlist')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cc-pdp-wishlist';
    function render() {
      var on = wl().indexOf(h) > -1;
      btn.classList.toggle('is-active', on);
      btn.innerHTML = HEART + '<span>' + (on ? 'In Wishlist' : 'Add to Wishlist') + '</span>';
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var a = wl(), i = a.indexOf(h);
      if (i > -1) a.splice(i, 1); else a.push(h);
      saveWl(a); render();
    });
    render();
    anchor.parentNode.insertBefore(btn, anchor.nextSibling);
    return btn;
  }

  function buildPincode(anchor) {
    if (document.querySelector('.cc-pincode')) return;
    var wrap = document.createElement('div');
    wrap.className = 'cc-pincode';
    wrap.innerHTML =
      '<div class="cc-pincode__label">' + TRUCK + '<span>Check delivery time</span></div>' +
      '<form class="cc-pincode__row" novalidate>' +
        '<input type="text" inputmode="numeric" maxlength="6" pattern="[0-9]{6}" ' +
        'class="cc-pincode__input" placeholder="Enter 6-digit pincode" aria-label="Delivery pincode">' +
        '<button type="submit" class="cc-pincode__btn">Check</button>' +
      '</form>' +
      '<p class="cc-pincode__out" role="status" aria-live="polite"></p>';
    var form = wrap.querySelector('form');
    var input = wrap.querySelector('input');
    var out = wrap.querySelector('.cc-pincode__out');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pin = (input.value || '').replace(/\D/g, '');
      if (pin.length !== 6) { out.textContent = 'Please enter a valid 6-digit pincode.'; out.className = 'cc-pincode__out is-error'; return; }
      /* TODO: replace this stub with a real Shiprocket serviceability lookup
         (courier ETA + COD availability) once the account/API key is live. */
      var lo = 3, hi = 7;
      out.innerHTML = 'Delivery to <strong>' + pin + '</strong> in <strong>' + lo + '–' + hi + ' days</strong> · COD available';
      out.className = 'cc-pincode__out is-ok';
    });
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
  }

  /* ------------------------------------------------------------------
     Description rework (founder change-set v2):
       "Make this section more interesting / Make the style tip more
        eyecatching / Add badges in the features section /
        Care needs to be Care Instructions"

     The catalogue body_html is a flat run of <p>/<ul> pairs:
       P intro · P "Style tip:" · P "Features:" + UL · P "Care Instructions:" + UL
     We tag those nodes so the CSS can turn the style tip into a callout and
     the features list into badge pills. Purely additive — if the copy shape
     ever changes, the description still renders as plain rich text.
     ------------------------------------------------------------------ */
  var FEATURE_ICONS = [
    [/tarnish/i,     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 3l7 3v5c0 4.4-3 8.3-7 10-4-1.7-7-5.6-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>'],
    [/water|swim|proof/i, '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 3s6 6.6 6 10.5A6 6 0 0 1 6 13.5C6 9.6 12 3 12 3z"/></svg>'],
    [/light\s*weight|lightweight/i, '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M20 4C10 4 4 10 4 20c8 0 16-6 16-16z"/><path d="M4 20L14 10"/></svg>'],
    [/skin|hypo|friendly/i, '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 20s-6.5-4.2-8.5-8A5 5 0 0 1 12 6a5 5 0 0 1 8.5 6c-2 3.8-8.5 8-8.5 8z"/></svg>']
  ];
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var BULB = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-3.5 10.9c.5.4.8 1 .8 1.6v.5h5.4v-.5c0-.6.3-1.2.8-1.6A6 6 0 0 0 12 3z"/></svg>';

  function iconFor(text) {
    for (var i = 0; i < FEATURE_ICONS.length; i++) {
      if (FEATURE_ICONS[i][0].test(text)) return FEATURE_ICONS[i][1];
    }
    return CHECK;
  }

  /* Find the rte block holding the catalogue copy. */
  function descriptionRoot() {
    var blocks = Array.prototype.slice.call(document.querySelectorAll('rte-formatter, .rte'));
    return blocks.filter(function (b) {
      return /style tip|features\s*:/i.test(b.textContent || '');
    })[0];
  }

  function headingLabel(p) {
    var strong = p.querySelector('strong, b');
    return (strong ? strong.textContent : p.textContent || '').trim();
  }

  function enhanceDescription() {
    var root = descriptionRoot();
    if (!root || root.dataset.ccDesc === '1') return;
    root.dataset.ccDesc = '1';
    root.classList.add('cc-desc');

    var nodes = Array.prototype.slice.call(root.children);
    nodes.forEach(function (node, i) {
      if (node.tagName !== 'P') return;
      var label = headingLabel(node);
      var next = nodes[i + 1];

      if (/^style\s*tip/i.test(label)) {
        node.classList.add('cc-styletip');
        /* the icon sits in a pseudo-free span so the callout can flex */
        var mark = document.createElement('span');
        mark.className = 'cc-styletip__icon';
        mark.innerHTML = BULB;
        node.insertBefore(mark, node.firstChild);
        return;
      }

      if (/^features/i.test(label)) {
        node.classList.add('cc-desc__head');
        if (next && next.tagName === 'UL') {
          next.classList.add('cc-featlist');
          Array.prototype.slice.call(next.children).forEach(function (li) {
            var txt = (li.textContent || '').trim();
            var ic = document.createElement('span');
            ic.className = 'cc-featlist__icon';
            ic.innerHTML = iconFor(txt);
            li.insertBefore(ic, li.firstChild);
          });
        }
        return;
      }

      if (/^care/i.test(label)) {
        /* founder: "Care needs to be Care Instructions". The catalogue data is
           being renamed too; this keeps older copy correct either way. */
        var strong = node.querySelector('strong, b');
        if (strong && /^care\s*:?\s*$/i.test(strong.textContent.trim())) {
          strong.textContent = 'Care Instructions:';
        }
        node.classList.add('cc-desc__head');
        if (next && next.tagName === 'UL') next.classList.add('cc-carelist');
      }
    });
  }

  function init() {
    enhanceDescription();
    var blocks = Array.prototype.slice.call(document.querySelectorAll('.buy-buttons-block'));
    var main = blocks.filter(function (b) { return !b.closest('.sticky-add-to-cart'); })[0] || blocks[0];
    if (!main) return;
    var h = handle();
    if (!h) return;
    var wishBtn = buildWishlist(main, h);
    buildPincode(wishBtn || main);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* Horizon renders the PDP from blocks and can swap the description in after
     DOMContentLoaded (and again on a variant change). Re-run the description
     pass when new nodes land; enhanceDescription() is guarded by a data flag
     so repeats are free. */
  new MutationObserver(function () { enhanceDescription(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
